module.exports = __webpack_public_path__ + "img/icon-money.d4965154.svg";